import { render, staticRenderFns } from "./SanifairForm.vue?vue&type=template&id=3244616e"
import script from "./SanifairForm.vue?vue&type=script&lang=ts"
export * from "./SanifairForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports